module.exports = __webpack_public_path__ + "img/daily.9988c407.svg";